import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { getFavorites } from "@/lib/storage";
import { CALCULATORS } from "@/lib/calculators";
import { useEffect, useState } from "react";

export default function Favorites() {
  const [favs, setFavs] = useState([]);
  useEffect(() => { setFavs(getFavorites()); }, []);
  const items = CALCULATORS.filter((c) => favs.includes(c.slug));

  return (
    <div data-testid="favorites-page">
      <div className="mb-6"><div className="overline mb-2">Pinned</div><h1 className="text-3xl sm:text-4xl font-black tracking-tighter">Favorites</h1><p className="text-muted-foreground mt-2 text-sm">Your pinned calculators for one-click access.</p></div>

      {items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-border p-12 text-center" data-testid="favorites-empty">
          <Bookmark className="w-8 h-8 text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
          <div className="font-medium">No favorites yet</div>
          <div className="text-sm text-muted-foreground mt-1">Open any calculator and tap the bookmark icon to pin it here.</div>
          <Link to="/" className="inline-block mt-4 h-10 px-4 rounded-md bg-primary text-primary-foreground text-sm font-semibold flex items-center justify-center w-max mx-auto">Browse calculators</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c) => (
            <Link key={c.slug} to={`/${c.slug}`} data-testid={`fav-tile-${c.slug}`} className="tile-lift group p-5 rounded-lg border border-border bg-card hover:border-primary/40 hover:shadow-md">
              <c.Icon className="w-6 h-6 text-primary mb-3" strokeWidth={1.75} />
              <div className="font-semibold text-sm">{c.title}</div>
              <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{c.description}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
